<template>
  <div class="d-flex mx-3 pb-10">
    <!-- <v-divider class="mt-0 mb-8" v-if="i > 0"></v-divider> -->
    <v-row style="width: 100%">
      <v-col :class="isSmAndUp() ? '' : 'px-0 px-0'"
             v-for="(sectionConfig, i) in sections"
             :key="i"
             :cols="colsSm(sectionConfig)"
             :md="colsMd(sectionConfig)"
             :xl="colsXl(sectionConfig)">
        <to-acknowledge v-if="isToAcknowledgeVisible(sectionConfig)"
                        :sectionConfig="sectionConfig"></to-acknowledge>
        <to-read v-else-if="isToReadVisible(sectionConfig)"
                 :sectionConfig="sectionConfig"></to-read>
        <read-history v-else-if="isReadHistoryVisible(sectionConfig)"
                      :sectionConfig="sectionConfig"></read-history>
        <module-link-list v-else-if="isModuleLinkListVisible(sectionConfig)"
                          :sectionConfig="sectionConfig"></module-link-list>
        <news-selection v-else-if="isNewsSelectionVisible(sectionConfig)"
                        :sectionConfig="sectionConfig"></news-selection>
        <documents-selection v-else-if="isDocumentsSelectionVisible(sectionConfig)"
                             :sectionConfig="sectionConfig"></documents-selection>
        <favorites v-else-if="isFavoritesVisible(sectionConfig)"
                   :sectionConfig="sectionConfig"></favorites>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ReadHistory from '@/view-widgets/ReadHistory';
import ToAcknowledge from '@/view-widgets/ToAcknowledge';
import ToRead from '@/view-widgets/ToRead';
import ModuleLinkList from '@/view-widgets/ModuleLinkList';
import NewsSelection from '@/view-widgets/NewsSelection';
import Favorites from '@/view-widgets/Favorites';
import DocumentsSelection from '@/view-widgets/DocumentsSelection';
import config from '@/common/config';

export default {
  name: 'ListOfSections',
  props: {
    sections: {
      type: Array,
    },
  },
  components: {
    ToAcknowledge,
    ToRead,
    ReadHistory,
    ModuleLinkList,
    NewsSelection,
    DocumentsSelection,
    Favorites,
  },

  methods: {
    isSmAndUp() {
      return this.$vuetify.breakpoint.smAndUp;
    },
    colsXl(sectionConfig) {
      switch (sectionConfig.layoutMaxCols) {
        case '3':
          return '4';
        case '2':
          return '6';
        default:
          return '12';
      }
    },
    colsMd(sectionConfig) {
      switch (sectionConfig.layoutMaxCols) {
        case '3':
          return '6';
        case '2':
          return '6';
        default:
          return '12';
      }
    },
    colsSm(sectionConfig) {
      switch (sectionConfig.layoutMaxCols) {
        case '3':
          return '12';
        case '2':
          return '12';
        default:
          return '12';
      }
    },
    imgUrl(fileName) {
      return `${config.apiUrl}/medias/tenantAssets/${fileName}?token=${this.token}`;
    },
    isAccessible(sectionConf) {
      //TODO:Implement
      return sectionConf.restrictedToMembersOfGroup === '';
    },
    //TODO: apply restrictions
    isToAcknowledgeVisible(sectionConf) {
      return sectionConf.widget === 'ToAcknowledge' && this.isAccessible(sectionConf);
    },
    isToReadVisible(sectionConf) {
      return sectionConf.widget === 'ToRead' && this.isAccessible(sectionConf);
    },
    isReadHistoryVisible(sectionConf) {
      return sectionConf.widget === 'ReadHistory' && this.isAccessible(sectionConf);
    },
    isModuleLinkListVisible(sectionConf) {
      return sectionConf.widget === 'ModuleLinkList' && this.isAccessible(sectionConf);
    },
    isNewsSelectionVisible(sectionConf) {
      return sectionConf.widget === 'NewsSelection' && this.isAccessible(sectionConf);
    },
    isDocumentsSelectionVisible(sectionConf) {
      return sectionConf.widget === 'DocumentsSelection' && this.isAccessible(sectionConf);
    },
    isFavoritesVisible(sectionConf) {
      return sectionConf.widget === 'Favorites' && this.isAccessible(sectionConf);
    },
  },
  computed: {
    token() {
      return this.$store.state.profile.user.token;
    },
  },
};
</script>
